import PropTypes from 'prop-types';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import IconButton from '../../../juristec-ui/core/IconButton';
import Button from '../../../juristec-ui/core/Button';
import {
  ArrowLeft,
  // NewColumn,
  VirtualAssistant,
  Compact,
  ExpandDiagonally,
  BookOpen,
  BookClosed,
  NewColumn,
} from '../../../juristec-ui/icons';

import { printSize, formatDateTime } from '../../../juristec-ui/utils/functions/lab';
import unsecureFileNames from '../../../utils/unsecureFileNames';
import useDeviceType from '../../../juristec-ui/hooks/useDeviceType';

import {
  MainContainer,
  ItensContainer,
  FileInfo,
} from './styled/FileViewDataToolbar.styled';

const fileViewDataToolbarDefaultPropOpenVirtualAssistant = () => {};

/**
 * A component to show and manage a file
*/
const FileViewDataToolbar = ({
  changed,
  ownerName = '',
  isOwner,
  fileName,
  fileSize,
  lastUpdate = '',
  handleOptimizer,
  // handleCustomColumns,
  openVirtualAssistant = fileViewDataToolbarDefaultPropOpenVirtualAssistant,
  goBack,
  compactView,
  setCompactView,
  showColumnsDescription,
  setShowColumnsDescription,
  handleCustomColumns,
  setTab,
}) => {
  const device = useDeviceType();

  const toggleColumnsDescriptsion = () => {
    setShowColumnsDescription(!showColumnsDescription);
    setTab('all');
  };

  return (
    <MainContainer>
      <ItensContainer className="left">
        <Tooltip text="Voltar" direction="right">
          <IconButton
            variant="contained"
            color="secondary"
            size="medium"
            shape="rounded"
            onClick={goBack}
          >
            <ArrowLeft />
          </IconButton>
        </Tooltip>
      </ItensContainer>
      <ItensContainer className="center">
        <h3 className="filename">
          {unsecureFileNames(fileName.replace('.metrics', ''))}
          {' '}
          (
          {printSize(fileSize).replace('.', ',')}
          )
        </h3>
        {device !== 'phone' && (
          <FileInfo>
            {ownerName && ownerName !== '' && (
              <span className="fileinfo">
                Proprietário:
                {' '}
                {ownerName}
              </span>
            )}
            {lastUpdate && lastUpdate !== '' && (
              <span className="fileinfo">
                Atualizado:
                {' '}
                {formatDateTime(lastUpdate, { time: 'half' })}
              </span>
            )}
          </FileInfo>
        )}
      </ItensContainer>
      <ItensContainer className="right">
        {changed ? (
          device !== 'phone' && (
            <Button
              variant="contained"
              color="secondary"
              size="medium"
              shape="rounded"
              onClick={handleOptimizer}
            >
              Revalidação
            </Button>
          )
        ) : (
          <>
            {Boolean(openVirtualAssistant) && (
              <>
                <Tooltip text="Assistente Virtual" direction="left">
                  <IconButton
                    variant="pattern"
                    color="primary"
                    size="medium"
                    shape="rounded"
                    onClick={openVirtualAssistant}
                  >
                    <VirtualAssistant />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <Tooltip text={compactView ? 'Visão normal' : 'Visão compacta'} direction="left">
              <IconButton
                variant="pattern"
                color="primary"
                size="medium"
                shape="rounded"
                onClick={() => setCompactView(!compactView)}
              >
                {compactView ? <ExpandDiagonally /> : <Compact />}
              </IconButton>
            </Tooltip>
            <Tooltip text={showColumnsDescription ? 'Ocultar sumário das colunas' : 'Mostrar sumário das colunas'}>
              <IconButton
                variant="pattern"
                color="primary"
                size="medium"
                shape="rounded"
                onClick={toggleColumnsDescriptsion}
              >
                {showColumnsDescription ? <BookClosed /> : <BookOpen />}
              </IconButton>
            </Tooltip>
            {device !== 'phone' && isOwner && (
              <>
                {/* COMENTADO POR ENQUANTO */}
                <Tooltip text="Colunas Customizadas" direction="left">
                  <IconButton
                    variant="pattern"
                    color="primary"
                    size="medium"
                    shape="rounded"
                    onClick={handleCustomColumns}
                  >
                    <NewColumn />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </>
        )}
      </ItensContainer>
    </MainContainer>
  );
};

FileViewDataToolbar.propTypes = {
  /**
   * bool that says if the user changed some column type
   */
  changed: PropTypes.bool.isRequired,
  /**
   * bool that says if the user changed some column type
   */
  ownerName: PropTypes.string,
  /**
   * A string with the name of the file
   */
  fileName: PropTypes.string.isRequired,
  /**
   * bool that marks if the user is the owner of this file
   */
  isOwner: PropTypes.bool.isRequired,
  /**
   * A number with the size of the file, in bytes
   */
  fileSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * A string with the datetime with the last update of the file
   */
  lastUpdate: PropTypes.string,
  /**
   * A function to validate data of the file
   */
  handleOptimizer: PropTypes.func.isRequired,
  /**
   * A function to enable the virtual assistant
   */
  openVirtualAssistant: PropTypes.func,
  /**
   * A function to return the browser history back
   */
  goBack: PropTypes.func.isRequired,
  /**
   * A boolean to check if the view is compact
   */
  compactView: PropTypes.bool.isRequired,
  /**
   * A function to change the view to compact or not
   */
  setCompactView: PropTypes.func.isRequired,
  /**
   * A boolean to check if the columns description is shown
   */
  showColumnsDescription: PropTypes.bool.isRequired,
  /**
   * A function to change the columns description visibility
   */
  setShowColumnsDescription: PropTypes.func.isRequired,
  /**
   * A function to add new columns to the file
   */
  handleCustomColumns: PropTypes.func.isRequired,
  /**
   * A function to change the tab of the columns description view
   */
  setTab: PropTypes.func,
};

export default FileViewDataToolbar;
